import React from 'react'

import { ReactComponent as IconEqual } from './assets/icons-help-panel-equal.svg'
import { ReactComponent as IconGreaterEqual } from './assets/icons-help-panel-greater-than-equal.svg'
import { ReactComponent as IconLess } from './assets/icons-help-panel-less-than.svg'
import { ReactComponent as IconNotEqual } from './assets/icons-help-panel-not-equal.svg'

import { ReactComponent as FigureEqual } from './assets/property-1-equal.svg'
import { ReactComponent as FigureGreaterEqual } from './assets/property-1-greater-than-or-equal.svg'
import { ReactComponent as FigureLessThan } from './assets/property-1-less-than.svg'
import { ReactComponent as FigureNotEqual } from './assets/property-1-not-equal.svg'

export default function () {
  return (
    <article>
      <div>
        <header>
          <h1>What does an Operator do?</h1>
        </header>
        <p>
          CHEC allows you to specify an operator when comparing the value of an
          input condition to a specified value.
        </p>
      </div>
      <section key="equal">
        <IconEqual />
        <div>
          <h2>
            Equal <em>(default)</em>
          </h2>
          <p>
            Use the “Equal” operator when you want the evaluation of the input
            condition to be “true” only when the value of the input condition
            equals the specified value.
          </p>
          <figure>
            <figcaption>Battery Voltage = 12.2V</figcaption>
            <FigureEqual />
          </figure>
        </div>
      </section>
      <section key="not-equal">
        <IconNotEqual />
        <div>
          <h2>Not Equal</h2>
          <p>
            Use the “Not Equal” operator when you want the evaluation of the
            input condition to be “true” only when the value of the input
            condition does not equal the specified value.
          </p>
          <figure>
            <figcaption>Battery Voltage ≠ 12.2V</figcaption>
            <FigureNotEqual />
          </figure>
        </div>
      </section>
      <section key="less-than">
        <IconLess />
        <div>
          <h2>Less Than</h2>
          <p>
            Use the “Less Than” operator when you want the evaluation of the
            input condition to be “true” only when the value of the input
            condition is less than the specified value.
          </p>
          <figure>
            <figcaption>Battery Voltage &lt; 12.2V</figcaption>
            <FigureLessThan />
          </figure>
        </div>
      </section>
      <section key="greater-than-or-equal">
        <IconGreaterEqual />
        <div>
          <h2>Greater Than or Equal</h2>
          <p>
            Use the “Greater Than or Equal” operator when you want the
            evaluation of the input condition to be “true” only when the value
            of the input condition is greater than or equal to the specified
            value.
          </p>
          <figure>
            <figcaption>Battery Voltage ≥ 12.2V</figcaption>
            <FigureGreaterEqual />
          </figure>
        </div>
      </section>
    </article>
  )
}
